import lazyLoad from "@loadable/component";
import createPlugin from "./createPlugin";
import LinkRowRenderer from "./Renderer";

const LinkRowForm = lazyLoad(() => import("./Form"));

const LinkRowPlugin = (settings) =>
    createPlugin({
        Renderer: LinkRowRenderer,
        Controls: LinkRowForm,
        ...settings,
    });

const LinkRow = LinkRowPlugin();
export default LinkRow;

export { LinkRowPlugin, LinkRowRenderer };
